import { CopyToClipboard } from '../../icons/copy-to-clipboard';
import { canCopy } from '../../utils/navigator';
import style from './style';

type CopyToClipboardProps = {
    dataToCopy: string,
};

const handleCopyClick = (value: string) => {
  if (!canCopy()) {
    // todo: implement another way
    return;
  }

  navigator.clipboard.writeText(value);
};

const CopyDataToClipboard = ({ dataToCopy }: CopyToClipboardProps):JSX.Element => {
  return (
    <>
      { canCopy() && (
        <CopyToClipboard style={ style.copyToClipboardIcon }
          onClick={ () => handleCopyClick(dataToCopy) }
        />
      )}
    </>
  );
};

export default CopyDataToClipboard;
